import React from 'react';
import FormProvider from '../../cnr/contexts/FormContext';
import { uniqueKey } from '../../common/keys';
import FormItems from './FormItems';

const FormWithProvider = (props) => <FormProvider  {...props} >
  <FormItems key={uniqueKey('fiwp')} />
</FormProvider>

export default FormWithProvider